<template>
  <div class="edu-about-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-12">
          <div class="edu-about-image">
            <img src="../../assets/img/all-img/about5.png" alt="banner-img" />
          </div>
        </div>
        <div class="col-lg-5 col-md-12">
          <div class="edu-about-content">
            <p class="sub-title">About Edumim</p>
            <h2>
              You Can Learn Anything, Anytime From
              <span class="shape02">Anywhere</span>
            </h2>
            <p>
              There are many variations of passages of Lorem Ipsum available,
              but the majority have suffered.
            </p>
            <div class="about-list">
              <div class="items">
                <div class="about-single-content">
                  <div class="icon">
                    <img src="../../assets/img/icon/video.svg" alt="icon" />
                  </div>
                  <div class="content">
                    <h3>All Classes Video Provided</h3>
                    <p>
                      There are many variations of passages of the Lorem Ipsum
                      available.
                    </p>
                  </div>
                </div>
              </div>
              <div class="items">
                <div class="about-single-content">
                  <div class="icon">
                    <img src="../../assets/img/icon/web-white.svg" alt="icon" />
                  </div>
                  <div class="content">
                    <h3>All Classes Video Provided</h3>
                    <p>
                      There are many variations of passages of the Lorem Ipsum
                      available.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>